import {css} from 'lit';
export const styles = css`article {
  --background: transparent;

  display: flex;
  align-items: flex-start;
}

ef-date-widget,
ef-icon[name='ban'],
ef-avatar {
  flex-shrink: 0;
  margin-right: 8px;
}

@media (min-width: 768px) {

ef-date-widget,
ef-icon[name='ban'],
ef-avatar {
    margin-right: 16px
}
  }

.content {
  display: flex;
  flex: 1 1 auto;
  padding: 8px;
  border-radius: 4px;
  background-color: var(--background);
}

ef-icon[name='ban'] {
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  color: var(--gray-700);
  font-size: 40px;
}

.details {
  flex: 1 1 auto;
}

.details > *:not(:last-child) {
    margin-bottom: 4px;
  }

.description {
  color: var(--text-secondary);
  font-size: 0.9em;
}

.option {
  color: var(--secondary-500);
  font-size: 0.9em;
}

article.t1 {
  --background: var(--primary-100);
}

article.t2 {
  --background: #e7e7e7;
}

article.t3 {
  --background: #dfe4f5;
}

article.t4 {
  --background: #fbe9cb;
}

article.t5 {
  --background: #eadbdb;
}
`;
export default styles;
